import React, { forwardRef, useImperativeHandle, useState } from "react";
import { FormControl, FormErrorMessage, FormLabel, Radio, RadioGroup, Stack } from "@chakra-ui/react";
import Option from "../../interfaces/Option";
import RequiredMark from "./RequiredMark";

interface InputRadioButtonProps {
  label: string;
  options: Array<Option>;
  isRequired: boolean;
  initValue: Option | undefined;
  getSelectedOption: (value: Option | undefined) => void;
}

const InputRadioButton = forwardRef((props: InputRadioButtonProps, ref) => {
  const [selectedOption, setSelectedOption] = useState<Option | undefined>(props.initValue);
  const [textError, setTextError] = useState<string>("");

  const handleSubmit = (value: string) => {
    const currentOption = props.options.find(option => option.value === value);
    setSelectedOption(currentOption);
    props.getSelectedOption(currentOption);
  };

  const validateValue = () => {
    if (props.isRequired && !selectedOption) {
      setTextError(`${props.label} jest wymagane`);
      return false;
    } else {
      setTextError("");
      return true;
    }
  };

  useImperativeHandle(ref, () => ({
    validate: () => validateValue(),
    value() { return selectedOption; }
  }));

  return (
    <FormControl isInvalid={!!textError} mt="5">
      <FormLabel>
        {props.label} {props.isRequired && <RequiredMark />}
      </FormLabel>
      <RadioGroup
        value={selectedOption?.value}
        onChange={(e) => handleSubmit(e)}
        onBlur={validateValue}
      >
        <Stack direction="column">
          {props.options.map((option, index) => (
            <Radio key={index} value={option.value}>
              {option.label}
            </Radio>
          ))}
        </Stack>
      </RadioGroup>
      <FormErrorMessage>{textError}</FormErrorMessage>
    </FormControl>
  );
});

export default InputRadioButton;
